import { SisType } from '../schemas';

/**
 * Popover で今見えている選択肢の選択だけ差し替え、見えていないコードは残す。
 * 種別切替や詳細条件で選択肢が変わっても、表に無い選択を消さない。
 */
export const replaceVisibleSisTypeCodes = (
  selectedSisTypeCodes: readonly string[],
  visibleSisTypes: readonly SisType[],
  nextVisibleSisTypes: readonly SisType[]
): string[] => {
  const visibleSisTypeCodeSet = new Set(
    visibleSisTypes.map((sisType) => sisType.code)
  );
  const codesNotInVisibleOptions = selectedSisTypeCodes.filter(
    (code) => !visibleSisTypeCodeSet.has(code)
  );
  return [
    ...codesNotInVisibleOptions,
    ...nextVisibleSisTypes.map((sisType) => sisType.code),
  ];
};

/**
 * 詳細条件適用後のテーブル行に存在するコードだけ残す。
 * 行が無いときは選択肢を出さない。
 */
export const filterSisTypesByPresentCodes = (
  sisTypes: SisType[],
  presentSisTypeCodes: readonly string[]
): SisType[] => {
  if (presentSisTypeCodes.length === 0) {
    return [];
  }

  const presentSisTypeCodeSet = new Set(presentSisTypeCodes);
  return sisTypes.filter((sisType) => presentSisTypeCodeSet.has(sisType.code));
};

/**
 * 行フィルタ用。テーブルに無いコードは効かせない（ヘッダ未選択＝全件と揃える）。
 */
export const filterSisTypeCodesByPresentCodes = (
  selectedSisTypeCodes: readonly string[],
  presentSisTypeCodes: readonly string[]
): string[] => {
  if (selectedSisTypeCodes.length === 0 || presentSisTypeCodes.length === 0) {
    return [];
  }

  const presentSisTypeCodeSet = new Set(presentSisTypeCodes);
  return selectedSisTypeCodes.filter((code) => presentSisTypeCodeSet.has(code));
};
